export const SET_TWO_FA_MOBILE_FORM = 'SET_VERIFY_MOBILE_CHANGE_FORM';
export const SET_2FA_SETTINGS = 'SET_2fa_SETTINGS';
export const SET_2FA_PROFILE_FLOW = 'SET_2FA_PROFILE_FLOW';

export const SET_TWO_FA_PASSWORD_FORM = 'SET_2FA_PASSWORD_FORM';
export const SET_TWO_FA_PASSWORD_DATA = 'SET_2FA_PASSWORD_DATA';
export const SET_2FA_EDIT_PROFILE_FLOW = 'SET_2FA_EDIT_PROFILE_FLOW';
